<template>
  <div class="c-pumps">
    <div
      class="c-pump"
      :class="{ 'c-pump--active': n === activePump }"
      @click="setActive(n)"
      v-for="n in amount"
    >
      {{ n }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'OPumpPicker',
  props: {
    amount: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      activePump: null
    }
  },
  methods: {
    setActive(index) {
      this.activePump = index
    }
  }
}
</script>

<style lang="scss">
.c-pumps {
  display: flex;
  flex-wrap: wrap;
  margin: -0.8rem;
}

.c-pump {
  border: 0.1rem solid rgba(#000, 0.1);
  border-radius: $border-radius-small;
  box-shadow: $box-shadow-list;
  color: $primary-color;
  color: var(--primary-color);
  cursor: pointer;
  font-size: 2.4rem;
  height: 7.2rem;
  line-height: 2.4rem;
  margin: 0.8rem;
  padding: 2.4rem 0;
  text-align: center;
  width: calc(33.33% - 1.6rem);
}
.c-pump--active {
  background: $primary-color;
  background: var(--primary-color);
  color: #fff;
}
</style>
